import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { setQueryMe, setUserData } from "../actions/accountActions";
import { INVESTOR } from "src/graphql/queries/investor";
import { useQuery } from "@apollo/react-hooks";

import { meQuery } from "src/types/me-types";

import LoadingWithPlainLayoutScreen from "src/components/LoadingWithPlainLayoutScreen";
import { useBrokerFromCookie } from "src/hooks";
interface authProps {
  children: any;
}

const Auth: React.FC<authProps> = ({ children }) => {
  const dispatch = useDispatch();
  const { addBrokerUsernameToCookie } = useBrokerFromCookie();
  const { loading, data, refetch } = useQuery<meQuery>(INVESTOR);

  const me = useMemo(() => {
    if (data?.investor?.__typename === "InvestorTypeResult") {
      return data.investor.investor;
    } else return undefined;
  }, [data]);

  if (me) {
    dispatch(setUserData(me));
    dispatch(setQueryMe(refetch));

    // addBrokerUsernameToCookie(me.broker.name,me.brokerUsername)
    if (me.__typename === "BitkubInvestor")
      addBrokerUsernameToCookie(me.broker.name, me.fullName);
    if (me.__typename === "SettradeInvestor")
      addBrokerUsernameToCookie(me.broker.name, me.brokerUsername);
  }

  if (loading) return <LoadingWithPlainLayoutScreen />;

  return children;
};

Auth.propTypes = {
  children: PropTypes.any,
};

export default Auth;
